import * as React from 'react';
import { Component } from 'react';
import { Query } from 'react-apollo';

import hoistNonReactStatics from 'js/lib/hoistNonReactStatics';

import type { AUTHENTICATION_MODAL_MODES_KEY } from 'bundles/authentication/constants';

import _t from 'i18n!nls/authentication';

import Redirection from './Redirection';
import type { OrgLoaderQuery, OrgLoaderQueryVariables } from './__generated__/OrgLoaderQuery';
import { OrganizationQuery } from './queries';

type OrganizationSSOProps = {
  navigate: (path: AUTHENTICATION_MODAL_MODES_KEY, options?: $TSFixMe) => void;
};

type State = {
  url?: string;
};

const withOrganizationSSO = <Props extends OrganizationSSOProps>(
  WrapperComponent: React.ComponentType<Props>,
  componentName = WrapperComponent.displayName ?? WrapperComponent.name
): React.ComponentClass<Props> => {
  class OrganizationSSO extends Component<Props> {
    static displayName = `withOrganizationSSO(${componentName})`;

    state: State = {};

    loadOrganization = ({ url }: { url: string }) => {
      this.setState({ url: url.toLowerCase() });
    };

    render() {
      const { url } = this.state;

      return (
        <Query<OrgLoaderQuery, OrgLoaderQueryVariables>
          query={OrganizationQuery}
          skip={!url}
          // That's why we use skip when there is no url but typescript doesn't understand :(
          variables={{ id: url || '' }}
        >
          {({ loading, data }) => {
            const id = data?.ThirdPartyOrganizationEmailDomainsV1Resource?.get?.thirdPartyOrganizationId;

            if (id) {
              return <Redirection {...(this.props as Props)} id={id} />;
            }

            const error = !loading && data ? _t('Organization not found') : undefined;

            return <WrapperComponent {...(this.props as Props)} error={error} onSubmit={this.loadOrganization} />;
          }}
        </Query>
      );
    }
  }

  hoistNonReactStatics(OrganizationSSO, Component);

  return OrganizationSSO;
};

export default withOrganizationSSO;
